<template>
  <vue-form @submit="submit"
           :disabled="isFormDisabled"
           :form="form"
           :action="action"
           :status="status">
    <section class="form-section">
      <header>
        <h3>Utilisateur</h3>
        <p>
          Le nom d'affichage est utilisé pour vous reconnaître dans l'application. Le
          pseudo vous permet de vous connecter à l'application.
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="display_name" label="Nom d'affichage">
          <vue-input id="display_name"
                     placeholder="ex: Jean"
                     :disabled="isFormDisabled"
                     v-model="form.display_name"/>
        </form-group>
        <form-group class="md:w-1/2" field="username" label="Pseudo">
          <vue-input id="username"
                     placeholder="ex: jeandupond"
                     :disabled="isFormDisabled"
                     v-model="form.username"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Mot de passe</h3>
        <p>
          Le mot de passe vous permet de vous connecter à l'application, veuillez choisir
          quelque chose de sécurisé.
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="password" label="Mot de passe">
          <vue-input type="password"
                     id="password"
                     :disabled="isFormDisabled"
                     v-model="form.password"/>
          <small v-if="model">
            Laissez vide si vous ne souhaitez pas le modifier.
          </small>
        </form-group>
        <form-group class="md:w-1/2" field="password_confirmation" label="Confirmer le mot de passe">
          <vue-input type="password"
                     id="password_confirmation"
                     :disabled="isFormDisabled"
                     v-model="form.password_confirmation"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Code</h3>
        <p>
          Ce code vous sera demandé lors du changement d'utilisateur ou pour déverrouiller l'application.
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="code" label="Code">
          <vue-input placeholder="ex: 4596" v-model="form.code" :disabled="isFormDisabled"/>
          <small v-if="model">Laissez vide si vous ne souhaitez pas le modifier.</small>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Boutique</h3>
        <p>
          La boutique de l'utilisateur
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="shop" label="Boutique">
          <select-shop v-model="form.shop" :config="{ disabled: isFormDisabled }"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Rôle</h3>
        <p>
          Le rôle définit les autorisations de l'utilisateur.
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="role" label="Rôle">
          <select-role v-model="form.role" :config="{ disabled: isFormDisabled }"/>
        </form-group>
      </div>
    </section>
    <section class="form-section" v-if="isUpdateForm && canDelete">
      <header>
        <h3>Zone de danger</h3>
        <p>
          L'utilisateur sera <strong>définitivement supprimé</strong> et ne pourra pas être restauré.
        </p>
      </header>
      <div>
        <form-group label="Voulez-vous supprimer définitivement cet utilisateur ?">
          <confirm-button @confirmed="destroy"
                          popover-type="popover-top-left sm:popover-right"
                          btn-class="btn-primary btn-outline"
                          btn-confirm-text="Supprimer"
                          :disabled="isFormDisabled"
                          :status="statusDestroy">Supprimer l'utilisateur</confirm-button>
        </form-group>
      </div>
    </section>
  </vue-form>
</template>

<script>
import Form from 'form-backend-validation';
import form from '../../mixins/form';
import SelectRole from '../roles/RoleSelect.vue';
import SelectShop from '../shops/ShopSelect.vue';

export default {
  mixins: [form],

  components: { SelectRole, SelectShop},

  data() {
    return {
      form: new Form({
        display_name: '',
        username: '',
        password: '',
        password_confirmation: '',
        role: '',
        shop: '',
        code: '',
      }),
    };
  },
};
</script>